__turbopack_context__.v({
  "container": "KE0Kia_container",
  "oops": "KE0Kia_oops",
});
